import { lazy, Suspense } from 'react'

import { LazySpinner } from '../../shared/spinner/Spinner'

const AboutUs = lazy(() => import('../components/home/AboutUs'))
const Achievements = lazy(() => import('../components/home/Achievements'))
const ContactUs = lazy(() => import('../components/home/ContactUs'))
const Carrousel = lazy(() => import('../components/home/Carrousel'))
const Information = lazy(() => import('../components/home/Information'))
const LandingLayout = lazy(() => import('../layout/LandingLayout'))

const LandingPage = () =>
    <Suspense fallback={ <LazySpinner/> }>
        <LandingLayout>
            <Carrousel />
            <AboutUs />
            <Information />
            <Achievements />
            <ContactUs />
        </LandingLayout>
    </Suspense>

export default LandingPage
